import { Instant } from '@js-joda/core';
import { useUser } from 'src/hooks/state';
import { useSelector } from 'src/store/hooks';
import { getIsSuperuserEnabledFlag } from 'src/store/selectors/auth';

export function useIsSuperuserEnabled(): boolean {
    const user = useUser();
    const superuserAccessEnabledUntil = useSelector(getIsSuperuserEnabledFlag);
    return Boolean(user?.isSuperuser && superuserAccessEnabledUntil?.isAfter(Instant.now()));
}
